<template>
  <DefaultLayout>
    <div class="card my-2" style="border: none;">
      <div class="container">
        <div class="row">
          <div class="col-md-12 pt-4 pb-sm-2">
            <div class="row position-relative overflow-hidden gx-2 zindex-1 py-1" style="min-height: 100vh;">
              <!--Contacts list-->
              <div class="col-md-4">
                <div class="position-xl-relative h-100 rounded border" style="box-shadow: -1px 2px 7px 0px rgba(0, 0, 0, 0.1);">
                  <div class="overflow-auto">
                    <!--Search-->
                    <div class="card-header w-100 d-flex px-3">
                        <div class="position-relative pt-2 w-100">
                          <input id="search_query" v-model="searchQuery" data-test="search_query" class="form-control" type="text" :placeholder="$t('network.filterByKeywords')" >
                          <i class="fas fa-search fs-lg text-nav position-absolute top-50 end-0 translate-middle-y me-3"></i>
                        </div>
                        <div class="position-relative ps-2 pt-2" style="font-size: 33px;">
                          <span v-if="noNetworks" class="text-primary pointer" :title="$t('start-a-new-conversation')" style="cursor: not-allowed;">
                            <i class="fa-solid fa-message-medical ps-1"></i>
                          </span>
                          <span v-else class="text-primary pointer" :title="$t('start-a-new-conversation')" @click="showNewChatModal = !showNewChatModal">
                            <i class="fa-solid fa-message-medical ps-1"></i>
                          </span>
                        </div>
                    </div>
                    <div class="card-body px-0 pb-4 pb-xl-0 pt-2">
                      <!--Contact-->
                      <a v-for="sender in senders" :key="sender.id" class="d-flex align-items-center text-decoration-none px-4 py-3 pointer"
                      :class="oppositeUser == sender ? 'bg-active' : ''" @click="oppositeUser = sender, newChatUser = false">
                        <div class="position-relative flex-shrink-0 my-1">
                          <avatar :src="sender.profile_image_url" :username="sender.first_name + ' ' + sender.last_name"
                          style="display: inline-block; width: 50px !important; height: 50px !important; background-size: 50px !important;"
                          ></avatar>
                        </div>
                        <div class="d-flex justify-content-between w-100 ps-2 ms-1 my-1">
                          <div class="me-3">
                            <div class="h6 mb-1">{{ sender.first_name + ' ' + sender.last_name }}</div>
                            <div v-if="sender.last_received_message.length > 60">
                              <p class="text-body fs-sm mb-0">{{ sender.last_received_message.slice(0,60) }}<span class="ms-n1">...</span></p>
                            </div>
                            <div v-else>
                              <p class="text-body fs-sm mb-0">{{ sender.last_received_message }}</p>
                            </div>
                          </div>
                          <div class="text-end">
                            <span class="d-block fs-xs text-muted">{{ getTimeAlt(sender.last_received_datetime) }}</span>
                          </div>
                        </div>
                      </a>
                      <span v-if="(!senders || senders.length == 0) && !busy && !noNetworks" class="px-3">
                        {{ $t('no-conversations-to-show') }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!--Chat window-->
              <div class="col-md-8">
                <div v-if="noNetworks">
                  <div class="card h-100 border align-items-center justify-content-center" style="min-height: 100vh; box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 7px 0px;">
                    <svg width="420" height="420" viewBox="0 0 420 420" fill="none" xmlns="http://www.w3.org/2000/svg" class="mt-n7">
                      <path d="M412 175.232V287.989C412 308.788 395.005 325.22 374.167 325.22H355.25V357.224C355.25 361.944 349.856 364.671 346.087
                      361.87L297.17 325.216L222.301 326.283C201.966 326.283 185 309.82 185 288.52V269.65L241.75 269.649C273.01 269.649 298.5 244.206
                      298.5 213.011V138H374.167C395.034 138 412 154.934 412 175.232Z" fill="#999999"/>
                      <path opacity="0.4" d="M242.154 62H71.8462C51.0012 62 34 78.9933 34 99.2965V213.314C34 234.12 51.0012 251.142 71.8462
                      251.142L90.7692 251.148V283.214C90.7692 287.941 96.1653 290.673 99.9351 287.869L148.869 251.151L242.154 251.083C262.999 251.157
                      280 234.131 280 213.302V99.2965C280 78.9933 263.028 62 242.154 62Z" fill="#005F9A"/>
                    </svg>
                    <span class="fs-5 fw-bold text-center px-4">
                      {{ $t('to-start-connecting-with-people-you-need-to-first-join-a-network-our-extensive-list-encompasses-a-diverse-array-of-subjects-and-interests-ensuring-theres-something-for-everyone-join-one-and-become-a-part-of-this-thriving-community') }}
                    </span>
                    <router-link :to="{ name: 'home' }" class="mt-3 fw-bold text-decoration-none fs-4">
                      {{ $t('explore-networks') }}
                    </router-link>
                  </div>
                </div>
                <div v-else class="card h-100 border">
                  <div v-if="oppositeUser && messages && !busy" class="card h-100 border" style="box-shadow: rgba(0, 0, 0, 0.1) -1px 2px 7px 0px;">
                    <div class="navbar card-header w-100 p-3" style="border-bottom-color: #5C6D80;">
                      <div class="d-flex align-items-center w-100 px-sm-3">
                        <div class="position-relative flex-shrink-0">
                          <avatar :src="oppositeUser.profile_image_url" :username="oppositeUser.first_name + ' ' + oppositeUser.last_name"
                          style="display: inline-block; width: 50px !important; height: 50px !important; background-size: 50px !important;"
                          ></avatar>
                        </div>
                        <div class="h5 ps-2 ms-1 mb-0">{{ oppositeUser.first_name + ' ' + oppositeUser.last_name }}</div>
                      </div>
                    </div>
                    <!--Body-->
                    <div class="card-body pb-0 pt-4">
                      <!--Messages-->
                      <div v-if="newChatUser" class="text-center">
                        <span class="badge rounded bg-info fs-6 p-2">
                          {{ $t('this-is-your-first-conversation-with-user-write-a-message-to-start', { user: oppositeUser.fullname }) }}
                        </span>
                      </div>
                      <div v-else>
                        <div v-for="(message, index) in sortedArray(messages, 'asc')" :key="index">
                          <div v-if="message.is_sent" class="ms-auto mb-3" style="max-width: 392px;">
                            <div class="d-flex align-items-end mb-2">
                              <div class="message-box-end text-dark rounded p-2" style="background: #C8FDF4;">
                                <span v-html="message.message.replaceAll('\n', '<br />')"></span>
                              </div>
                              <div class="flex-shrink-0 ps-2 ms-1">
                                <avatar :src="user.profile_image_url" :username="user.first_name + ' ' + user.last_name"
                                style="display: inline-block; width: 50px !important; height: 50px !important; background-size: 50px !important;"
                                ></avatar>
                              </div>
                            </div>
                            <div class="fs-xs text-muted">{{ getTime(message.created_at) }}</div>
                          </div>
                          <div v-if="!message.is_sent" class="mb-3" style="max-width: 392px;">
                            <div class="d-flex align-items-end mb-2">
                              <div class="flex-shrink-0 pe-2 me-1">
                                <avatar :src="oppositeUser.profile_image_url" :username="oppositeUser.first_name + ' ' + oppositeUser.last_name"
                                style="display: inline-block; width: 50px !important; height: 50px !important; background-size: 50px !important;"
                                ></avatar>
                              </div>
                              <div class="message-box-start text-dark rounded p-2" style="background: #D9D9D9;">
                                <span v-html="message.message.replaceAll('\n', '<br />')"></span>
                              </div>
                            </div>
                            <div class="fs-xs text-muted text-end">{{ getTime(message.created_at) }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--Footer (Textarea)-->
                    <div class="card-footer w-100 border px-0">
                      <div class="d-flex align-items-end border rounded-3 pb-2 pe-2 mx-sm-3">
                        <CreateMessage :user_id="oppositeUser.opposite_user_id" :newChatUser="newChatUser" @user-message-sent-event="messageSentEvent" />
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="card h-100 border align-items-center justify-content-center" style="min-height: 100vh; box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 7px 0px;">
                      <svg v-if="!busy" width="420" height="420" viewBox="0 0 420 420" fill="none" xmlns="http://www.w3.org/2000/svg" class="mt-n7">
                        <path d="M412 175.232V287.989C412 308.788 395.005 325.22 374.167 325.22H355.25V357.224C355.25 361.944 349.856 364.671 346.087
                        361.87L297.17 325.216L222.301 326.283C201.966 326.283 185 309.82 185 288.52V269.65L241.75 269.649C273.01 269.649 298.5 244.206
                        298.5 213.011V138H374.167C395.034 138 412 154.934 412 175.232Z" fill="#999999"/>
                        <path opacity="0.4" d="M242.154 62H71.8462C51.0012 62 34 78.9933 34 99.2965V213.314C34 234.12 51.0012 251.142 71.8462
                        251.142L90.7692 251.148V283.214C90.7692 287.941 96.1653 290.673 99.9351 287.869L148.869 251.151L242.154 251.083C262.999 251.157
                        280 234.131 280 213.302V99.2965C280 78.9933 263.028 62 242.154 62Z" fill="#005F9A"/>
                      </svg>
                      <span v-if="!busy" class="fs-4 fw-bold text-center px-4">
                        {{ $t('here-you-can-access-the-messages-that-have-been-sent-to-you-and-establish-connections-with-fellow-members-of-resonance-networks') }}
                      </span>
                      <div v-if="busy">
                        <lottie-player
                          autoplay
                          loop
	                        speed="2.5"
                          src="/img/animations/custom_loader.json"
                          style="top: 35vh; height: 130px;"
                          >
                        </lottie-player>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="showNewChatModal" hide-footer hide-header size="md">
      <span class="fs-4 fw-semibold">{{ $t('start-a-new-conversation') }}</span>
      <hr style="opacity: 0.9; height: 1px;" />
      <span>
        {{ $t('only-fellow-network-members-with-the-option-to-accept-new-messages-turned-on-will-be-reflected-in-the-results') }}
      </span>
      <div class="card-header w-100 border-0 px-3 pt-4 pb-2">
        <div class="position-relative">
          <input id="search_user_query" v-model="searchUserQuery" data-test="search_user_query" class="form-control" type="text" :placeholder="$t('search-by-name')" >
          <i class="fas fa-search fs-lg text-nav position-absolute top-50 end-0 translate-middle-y me-3"></i>
        </div>
      </div>
      <hr v-if="searchUserQuery.length > 0" style="opacity: 0.9; height: 1px; margin-bottom: 10px;" />
      <div v-if="searchUserQuery.length > 0 && loading" class="row text-center mt-3">
        <i class="fas fa-3x fa-spinner"></i>
      </div>
      <table v-if="filteredUsers.length > 0" class="table mb-0">
        <tbody>
          <tr v-for="user in filteredUsers" :key="user.user_id" style="border-style: hidden;">
              <td>
                <avatar
                    :size="45"
                    :username="user.fullname"
                    class="float-start me-3"
                    :src="user.profile_image_url"
                ></avatar>
                <div class="float-start mt-2">
                  <span>{{ user.fullname }}</span>
                </div>
                <span class="float-end text-primary fw-semibold pointer mt-2" @click="getMessages(user.user_id)">
                  {{ $t('network.member.message') }}
                </span>
              </td>
          </tr>
        </tbody>
      </table>
      <div v-if="!loading && searchUserQuery.length != 0 && filteredUsers.length == 0" class="text-center mt-3 fw-semibold">
        <span>
          {{ $t('no-users-match-your-search') }}
        </span>
      </div>
    </b-modal>
  </DefaultLayout>
</template>
<script>
import DefaultLayout from '../layouts/default';
import CreateMessage from '@/views/messages/CreateMessage.vue';
import Avatar from 'vue-avatar';
import moment from 'moment';
import { orderBy, debounce } from 'lodash';

export default {
  components: {
    DefaultLayout,
    CreateMessage,
    Avatar,
  },
  data() {
    return {
      user: this.$store.getters['user'],
      senders: null,
      busy: true,
      loading: false,
      newMessage: '',
      messages: [],
      oppositeUser: null,
      newChatUser: false,
      searchQuery : '',
      searchUserQuery : '',
      sender_id: this.$route.query.user,
      noNetworks: false,
      showNewChatModal: false,
      filteredUsers: [],
    };
  },
  watch: {
    oppositeUser(newV) {
      if (newV != null && !this.newChatUser) {
        this.getMessages(newV.opposite_user_id);
      }
    },
    searchQuery: debounce(function (query) {
      this.search(query);
    }, 600),
    searchUserQuery: debounce(function (query) {
      this.searchUser(query);
    }, 600),
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.busy = true;
      // checks if user is member of any networks
      this.$http.get('notification-events').then(resp => {
         let my_networks = resp.data.my_networks;
        if (my_networks.length == 0) {
          this.noNetworks = true;
        }
      });
      this.$http.get('user-messages/chat-list').then(resp => {
        this.senders = resp.data;
        if (this.sender_id) {
          this.oppositeUser = resp.data.find(s => s.opposite_user_id == this.sender_id);
          if (this.oppositeUser == null) {
            this.getMessages(this.sender_id);
          }
        }
      });
      this.busy = false;
    },
    messageSentEvent(data) {
      this.busy = true;
      this.getMessages(data['recipient_user_id']);
      this.$http.get('user-messages/chat-list').then(resp => {
        this.senders = resp.data;
        this.oppositeUser = resp.data.find(s => s.opposite_user_id == data['recipient_user_id']);
        this.busy = false;
      });
    },
    getMessages(user_id) {
      this.busy = true;
      this.showNewChatModal = false;
      this.newChatUser = false;
      this.$http.get('user-messages?user_id=' + user_id).then(resp => {
        if (resp.data.messages.length > 0) {
          this.messages = resp.data.messages;
        } else {
          this.newChatUser = true;
          this.oppositeUser = resp.data.opposite_user;
          this.oppositeUser.opposite_user_id = resp.data.opposite_user.user_id;
          this.messages.push({ is_new: true });
        }
        this.busy = false;
      });
    },
    getTimeAlt(time) {
      return moment.utc(time).local().format("HH:mm");
    },
    getTime(time) {
      return moment(time).format("MMM D, YYYY • HH:mm");
    },
    sortedArray(array, order) {
      return orderBy(array, 'created_at', order);
    },
    search(query) {
      this.busy = true;
      if (query.length > 0){
        this.$http.get('user-messages/search?query=' + query).then(resp => {
          this.senders = resp.data;
          if (this.senders.length != 0) {
            this.oppositeUser = this.senders[0] ?? this.senders[1];
          }
          this.busy = false;
        });
      } else {
        this.load();
      }
    },
    searchUser(query) {
      this.filteredUsers = [];
      this.loading = true;
      if (query.length > 0){
        this.$http.get('user-messages/search-users?query=' + query).then(resp => {
          this.filteredUsers = resp.data;
          this.loading = false;
        });
      } else {
        this.filteredUsers = [];
        this.loading = false;
      }
    },
  },
};
</script>
<style>
.message-box-end {
  border-top-left-radius: var(--ar-border-radius-lg);
  border-top-right-radius: var(--ar-border-radius-lg);
  border-bottom-left-radius: var(--ar-border-radius-lg);
}
.message-box-start {
  border-top-left-radius: var(--ar-border-radius-lg);
  border-top-right-radius: var(--ar-border-radius-lg);
  border-bottom-right-radius: var(--ar-border-radius-lg);
}
.message-box-start, .message-box-end {
  width: 100%;
  padding: 1rem;
  background-color: var(--ar-gray-200);
}
.bg-active {
  background-color: #f1f1f1;
}
</style>
